module.exports = __webpack_public_path__ + "assets/images/novasport_3.2c62adaec11c6fc2080a84cea19e7c3f.png";